module.exports = __webpack_public_path__ + "img/article_1_4.e6a5a53c.png";